<template>
  <div class="fill">
    <v-row>
      <v-col cols="8" class="py-0 mt-8">
        <div v-if="sub1" class="title red--text">{{sub1}}</div>
        <div v-if="titulo" class="display-1">{{titulo}}</div>
        <div v-if="sub2" class="subtitle-2">{{sub2}}</div>
      </v-col>

      <v-col cols="4" class="d-flex justify-end align-center mt-8 py-0">
        <v-btn class="mr-5" @click="videoDialog = true" v-if="hasVideo" dark color="green">
          <v-icon dark class="mr-1">mdi-video</v-icon>
          <span>Video</span>
        </v-btn>

        <BtnShare />

        <div class="text-center">
          <v-dialog v-model="videoDialog" width="50%">
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title>Video</v-card-title>
              <v-row class="mx-0">
                <video width="100%" controls>
                  <source :src="video" type="video/mp4" />
                  <source :src="video" type="video/ogg" />
                </video>
              </v-row>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="videoDialog = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BtnShare from "@/components/BtnShare.vue";
export default {
  name: "ComponenTitle",
  components: {
    BtnShare
  },
  props: ["sub1", "titulo", "sub2", "video", "hasVideo"],
  data() {
    return {
      videoDialog: false
    };
  },
  methods: {
    btnShare(id) {
      var btnShare = document.getElementById(id);
      btnShare.click();
    }
  },
  async mounted() {}
};
</script>
